export default __webpack_public_path__ + "static/media/28.d9562d1b.jpg";